import { requireScript } from 'bv';

const { FeatureGuard, JSBundles } = window;

let promise;

export default () => {
  promise = promise || FeatureGuard.guard('iovation')
    .then((enabled) => {
      if (!enabled) return null;

      return requireScript(JSBundles.IovationLoader)
        .then(() => window.IovationLoader.default());
    })
    .catch(() => null);

  return promise;
};
